import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { CurrentAccountInformationComponent } from './current-account-information/current-account-information.component';
import { SpvCustomAccountInformationComponent } from './spv-custom-account-information/spv-custom-account-information.component';

@Component({
	selector: 'app-account-information',
	templateUrl: './account-information.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./account-information.component.scss'],
	imports: [
		MatTabGroup,
		MatTab,
		CurrentAccountInformationComponent,
		SpvCustomAccountInformationComponent,
	],
})
export class AccountInformationComponent {}
